import { inject, Injectable } from '@angular/core';
import { WebProviderService } from '../web/web.provider.service';
import { environment } from 'src/environments/environment';
import { B2BSearchItem } from 'src/app/interfaces/b2b-search-item';

@Injectable({
  providedIn: 'root'
})
export class B2bSearchItemProviderService {

    private webProvider = inject(WebProviderService);
    private readonly baseURL = environment.apiURL;
    private get attributeURL() {
      return '/api/B2BSearchItems';
    }

    async get(token: string): Promise<B2BSearchItem[]> {
      const searchItemResults = await this.webProvider.get<B2BSearchItem[]>(`${this.baseURL}${this.attributeURL}?token=${token}`);
      return searchItemResults ?? [];
    }
}
